import * as Utils from 'generic/utility'
import { isEmpty } from 'lodash'
import React, {Component} from 'react'
import { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './styles.css'
import {TinymceEditorComponent} from './tinymceditor'

interface WysiwygEditorState {
  currentColor: string,
  currentTab: number,
  htmlChanged: boolean,
  html: string,
  lastWysiwygHtml: string,
  placeholder: string,
}

interface WysiwygEditorProps {
  html: string,
  htmlEdited: boolean,
  onChange: any,
  placeholder?: string,
  qlContainerClassName?: string,
  defaulFontSize?: string,
  defaultFonSizeClass?: string,
  displayHtmlTab?: boolean,
  onTabChange?: any,
  showCharacterCount?: boolean,
  maxCharacterCount?: number,
}

const DEFAULT_EDITOR_TAB: number = 0
const WYSIWYG_EDITOR_TAB: number = 1
export const HTML_SWITCH_PROMPT = 'If you switch to text editor after adding HTML, it will remove the latest changes. Do you want to continue?'
export const HTML_SWITCH_CLEAR_PROMPT = 'If you switch to text editor after adding HTML, it will remove the HTML. Do you want to continue?'

export class WysiwygEditor extends Component<WysiwygEditorProps, WysiwygEditorState> {
  private quilEditor
  constructor(props: WysiwygEditorProps) {
    super(props)
    this.state = {
      currentColor: '',
      currentTab: this.isHtmlEdited() ? WYSIWYG_EDITOR_TAB : DEFAULT_EDITOR_TAB,
      html: props.html,
      htmlChanged: false,
      lastWysiwygHtml: this.isHtmlEdited() ? '' : props.html,
      placeholder: props.placeholder || 'Enter your text here',
    }
    this.colorChange = this.colorChange.bind(this)

  }

  public componentDidMount() {
    const qlContainer = document.getElementsByClassName(this.props.qlContainerClassName || 'ql-container')
    this.quilEditor = qlContainer && qlContainer.length ? Quill.find(qlContainer[0]) : {}
  }

  public render() {
    return (
      <div className="r-wysiwyg">
        <Tabs selectedIndex={this.props.displayHtmlTab ? 1 : this.state.currentTab}
              onSelect={(index: number) => (this.selectTab(index))}>
          <TabList>
            <Tab id="quill-text-tab">Text</Tab>
            <Tab >HTML</Tab>
          </TabList>
          <TabPanel>
            <TinymceEditorComponent html={this.props.html}
            showCharacterCount={this.props.showCharacterCount}
            maxCharacterCount={this.props.maxCharacterCount}
            onChange={(content) => {this.handleWysiwygChange(content)}}></TinymceEditorComponent>
            </TabPanel>
          <TabPanel >
            <textarea className="wysiwyg-preview-html"
              value={this.props.html}
              onChange={(event: any) => this.handleRawEditorChange(event.target.value)}/>
          </TabPanel>
        </Tabs>
      </div>
    )
  }

  private colorChange(color) {
    if (this.quilEditor && this.quilEditor.format) {
      this.quilEditor.format('color', color)
    }
    this.setState({
      currentColor: color,
    })
  }

  private selectTab = (index: number) => {
    if ( this.props.onTabChange) {
      this.props.onTabChange(index)
    }
    if ( index === DEFAULT_EDITOR_TAB ) {
      this.returnToText()
    } else if ( index === WYSIWYG_EDITOR_TAB ) {
      this.startHtmlEditing()
    }
  }

  private returnToText = () => {
    if (this.state.htmlChanged) {
      const msg: string = !isEmpty(this.state.lastWysiwygHtml) ?
        HTML_SWITCH_PROMPT : HTML_SWITCH_CLEAR_PROMPT
      if (window.confirm(msg)) {
        this.setState({
          html: this.state.lastWysiwygHtml,
          htmlChanged: false,
          currentTab: DEFAULT_EDITOR_TAB,
        })
        this.props.onChange(this.state.lastWysiwygHtml, false)
      }
    } else {
      this.setState({
        currentTab: DEFAULT_EDITOR_TAB,
      })
    }
  }

  private handleWysiwygChange = (html: string) => {
    this.setState({
      html,
      lastWysiwygHtml: html,
    })
    this.props.onChange(html, false)
  }

  private handleRawEditorChange = (html: string) => {
    this.setState({
      html,
      htmlChanged: true,
    })
    this.props.onChange(html, true)
  }

  private isHtmlEdited = (): boolean => {
    // Input - if this represents HTML edited props, or if we've edited
    return Utils.isTruthy(this.props.htmlEdited) || (this.state && this.state.htmlChanged)
  }

  private startHtmlEditing = (): void => {
    this.setState({
      currentTab: WYSIWYG_EDITOR_TAB,
    })
  }
}
